import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const PrintPayouts = {
  Reports: lazyNamed(() => import('./containers/Reports/index.tsx'), 'Reports'),
  NumberRanges: lazyNamed(() => import('./containers/NumberRanges/index.tsx'), 'NumberRanges'),
  AdMediums: lazyNamed(() => import('./containers/AdMediums/index.tsx'), 'AdMediums'),
  PayoutConfigs: lazyNamed(() => import('./containers/PayoutConfigs/index.tsx'), 'PayoutConfigs'),
  PayoutConfigForm: lazyNamed(() => import('./containers/PayoutConfigForm/index.tsx'), 'PayoutConfigForm'),
  Positions: lazyNamed(() => import('./containers/Positions/index.tsx'), 'Positions'),
};
